var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseRoundedB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12368",
    "data-name": "Group 12368",
    transform: "translate(-720 -361)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_750",
    "data-name": "Ellipse 750",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(720 361)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_47_",
    "data-name": "svgexport-6 (47)",
    transform: "translate(726.32 367.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M3.27,2.7l2-2a.294.294,0,0,0,0-.414L5.1.1a.294.294,0,0,0-.415,0l-2,2-2-2A.294.294,0,0,0,.261.1L.086.277a.293.293,0,0,0,0,.414l2,2-2,2a.294.294,0,0,0,0,.415l.176.176a.294.294,0,0,0,.414,0l2-2,2,2a.291.291,0,0,0,.207.086h0A.291.291,0,0,0,5.1,5.289l.176-.176a.294.294,0,0,0,0-.415Z",
    transform: "translate(0 -0.016)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundedB);
export default __webpack_public_path__ + "static/media/close-rounded-b.495410382b5da41329720d9b70677c6f.svg";
export { ForwardRef as ReactComponent };